// extracted by mini-css-extract-plugin
module.exports = {"section":"nosMove_section__UnZY8","buttons":"nosMove_buttons__FvY5N","containerButton":"nosMove_containerButton__m8TFG","cards":"nosMove_cards__cL7va","card":"nosMove_card__X_Wwh"};